import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string;
}

interface ZonaImovel {
  id: string;
  nome: string;
}

interface BairroImovel {
  id: string;
  nome: string;
}

export interface LeadPreferenciasInterface {
  idLeadCorretor: string;
  idLead: string;
  idTipoEmpreendimento: string;
  tipoEmpreendimento: string;
  idPrazoEntregaImovel: string;
  prazoEntregaImovel: string;
  inicioIntervaloMetragemImovel: number;
  fimIntervaloMetragemImovel: number;
  inicioIntervaloValorImovel: string;
  fimIntervaloValorImovel: string;
  zonaImovel: ZonaImovel[];
  bairroImovel: BairroImovel[];
  idEmpreendimento: string | null;
  nomeEmpreendimento: string | null;
}

export function usePreferenciasV2(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const PREFERENCIASV2 = `${leadsWebEnviroment}/commom/leads/preferencias/v2/${props.idLeadCorretor}`;
    const response = await instance.get(PREFERENCIASV2);

    return response?.data?.data?.dataResponse as LeadPreferenciasInterface;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar dados complementares. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
